import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { wasCreatedByNewInfo } from '../../utils/gallery';
import { optionsMap, GALLERY_CONSTS } from 'pro-gallery-lib';
import '../../assets/styles/overlayHoverAnimations.scss';
export const WixProGalleryStylableOverlayAnimations = WixProGallery => props => {
  const shouldUseNewInfo = wasCreatedByNewInfo(props.options);
  const animationType = props.options[optionsMap.behaviourParams.item.overlay.hoverAnimation];
  const animationBehavior = props.options.controllers_behaviourParams_item_overlay_hoverAnimationBehavior;
  if (!shouldUseNewInfo) {
    return /*#__PURE__*/React.createElement(WixProGallery, props);
  }
  const animationClass = animationType.toLowerCase().replaceAll('_', '-');
  const animationBehaviorClass = `animation-${animationBehavior.toLowerCase()}`;
  const options = {
    ...props.options,
    [optionsMap.behaviourParams.item.overlay.hoverAnimation]: GALLERY_CONSTS.behaviourParams_item_overlay_hoverAnimation.NO_EFFECT
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `pro-gallery-overlay-animation-wrapper ${animationClass} ${animationBehaviorClass}`
  }, /*#__PURE__*/React.createElement(WixProGallery, _extends({}, props, {
    options: options
  })));
};
//# sourceMappingURL=withStylableOverlayAnimations.js.map